import React, { useEffect, useState } from "react";
import { HERO_SLIDES } from "@/data/site";
import { ChevronLeft, ChevronRight } from "lucide-react";

const Hero = () => {
    const [i, setI] = useState(0);
    const n = HERO_SLIDES.length;

    useEffect(() => {
        const t = setInterval(() => setI((v) => (v + 1) % n), 6500);
        return () => clearInterval(t);
    }, [n]);

    const slide = HERO_SLIDES[i];

    return (
        <section className="acd-hero" data-testid="hero-slider">
            {HERO_SLIDES.map((s, idx) => (
                <div
                    key={s.title}
                    className="acd-hero-bg"
                    style={{
                        backgroundImage: `url(${s.bg})`,
                        opacity: idx === i ? 0.55 : 0,
                        transition: "opacity 1.2s ease",
                    }}
                />
            ))}
            <div className="acd-hero-overlay" />
            <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-8 py-24 md:py-32 flex flex-col justify-center min-h-[620px]">
                <div key={i} className="acd-fade-in max-w-2xl">
                    <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
                        {slide.title}
                    </h1>
                    <p className="text-white/85 text-base md:text-lg mb-8 max-w-xl">
                        {slide.text}
                    </p>
                    <a
                        href={slide.link}
                        target="_blank"
                        rel="noreferrer"
                        className="acd-btn-gradient"
                        data-testid={`hero-cta-${i}`}
                    >
                        {slide.cta}
                    </a>
                </div>

                <div className="absolute bottom-10 left-6 md:left-8 flex gap-3">
                    <button
                        onClick={() => setI((v) => (v - 1 + n) % n)}
                        className="w-12 h-12 rounded-full border border-white/40 text-white flex items-center justify-center hover:bg-white/10 transition"
                        aria-label="Slide anterior"
                        data-testid="hero-prev"
                    >
                        <ChevronLeft size={22} />
                    </button>
                    <button
                        onClick={() => setI((v) => (v + 1) % n)}
                        className="w-12 h-12 rounded-full border border-white/40 text-white flex items-center justify-center hover:bg-white/10 transition"
                        aria-label="Próximo slide"
                        data-testid="hero-next"
                    >
                        <ChevronRight size={22} />
                    </button>
                </div>
            </div>
        </section>
    );
};

export default Hero;
